
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import OMRScanner from "./OmrScan";
import Scanner from "./Scanner";

const Exam = ({ student }) => {
  const [exams, setExams] = useState([]);
  const [result, setResult] = useState([]);
  const [selectedExam, setSelectedExam] = useState(null);
  const [selectedUploadExam, setSelectedUploadExam] = useState(null);
  const [selectedResult, setSelectedResult] = useState(null);
    const [showAnswerModal, setShowAnswerModal] = useState(false);
    const [selectedAnswers, setSelectedAnswers] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [showResult, setShowResult] = useState(null);

    const [visibleCount, setVisibleCount] = useState(20);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

    const filteredData = exams.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

  // Fetch exams and results
  useEffect(() => {
    const fetchExams = async () => {
      if (!student?.class_id) return;
        setLoading(true);
      try {
        const res = await axios.get(
          `https://api.scannscore.com/get_exam/${student.class_id}`
        );
        setExams(res.data || []);
      } catch (err) {
        toast.error("Failed to fetch exams");
      }finally {
    setLoading(false);
  }
    };


    fetchExams();
    fetchResult();
  }, [student]);

  // console.log(exams,'exam')

  const handleShowResult = (exam, res) => {
    setSelectedResult({
      ...res,
      examData: exam,
    });
  };

      const fetchResult = async () => {
      if (!student?.id) return;
      try {
        const res = await axios.get(
          `https://api.scannscore.com/fetch-result/${student.id}`
        );
        setResult(res.data || []);
      } catch (err) {
        toast.error("Failed to fetch results");
      }
    };


  const handleResult = (data) => {
    setResult((prev) => [...prev, data]);
    setSelectedExam(null);
fetchResult();
  };


  const handleUploadResult = async (data) => {
    setResult((prev) => [...prev, data]);
    setSelectedUploadExam(null);
    setShowResult(data);
    await storeResult({
      class_id: student.class_id,
      std_id: student.id,
      exam_id: data.examData.id,
     report: data.report,
score:     data.score,
    correct: data.correct, 
     wrong: data.wrong, 
       omr_image: data.annotatedImage?.replace(
    "data:image/jpeg;base64,",
    "")
    })
    
// fetchResult();
  };

const base64ToBlob = (base64, mime = "image/jpeg") => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: mime });
};

const storeResult = async ({
  class_id,
  std_id,
  exam_id,
  report,
  score,
  correct,
  wrong,
  omr_image
}) => {
  const formData = new FormData();

  const reportObj = {};
  report?.forEach((item) => {
    reportObj[String(item.q_no)] = item.marked;
  });

  formData.append("class_id", class_id);
  formData.append("exam_id", exam_id);
  formData.append("student_id", std_id);
  formData.append("answer", JSON.stringify(reportObj));
  formData.append("score", score);
  formData.append("correct", correct);
  formData.append("wrong", wrong);

  // image
  if (omr_image) {
    const blob = base64ToBlob(
      omr_image.replace("data:image/jpeg;base64,", ""),
      "image/jpeg"
    );

    formData.append(
      "omr_image",
      blob,
      `annotated_${std_id}_${exam_id}.jpg`
    );
  }

  try {
    const res = await fetch(
      "https://api.scannscore.com/upload_omr_result",
      {
        method: "POST",
        body: formData,
      }
    );

    if (res.ok) {
      // const data = await res.json();
      fetchResult();
      // alert("Result stored successfully ✅");
      // return data;
    } else {
      const err = await res.text();
      alert("Failed to store result ❌");
      console.error(err);
    }
  } catch (error) {
    console.error("API Error:", error);
  }
};
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
  
      // when user reaches bottom (threshold 100px)
      if (scrollTop + windowHeight >= docHeight - 100) {
        loadMore();
      }
    };
  
    window.addEventListener("scroll", handleScroll);
  
    return () => window.removeEventListener("scroll", handleScroll);
  }, [filteredData, visibleCount]);
  
  
  const loadMore = () => {
    if (loadingMore) return;
    if (visibleCount >= filteredData.length) return;
  
    setLoadingMore(true);
  
    setTimeout(() => {
      setVisibleCount((prev) => prev + 20);
      setLoadingMore(false);
    }, 300); 
  };
   useEffect(() => {
    setVisibleCount(20);
  }, [searchTerm]);
  
  
  
  const visibleData = filteredData.slice(0, visibleCount);
  


  const renderActivity = (exam) => {
    const matchedResult = result.find((res) => res.exam_id === exam.id);

    if (exam.status === "closed" || matchedResult) {
      return (
        <button
          className="btn btn-success"
          onClick={() => handleShowResult(exam, matchedResult)}
        >
         View Result
        </button>
      );
    }

    if (!exam.questions || exam.questions.length === 0) {
      return <span className="text-danger">Upcoming Exam</span>;
    }

    if (exam.status === "open") {
      return (
        <>
        <button
          className="btn btn-warning me-2"
          onClick={() => setSelectedExam(exam)}
        >
          Scan
        </button>
        <button
          className="btn btn-primary"
          onClick={() => setSelectedUploadExam(exam)}
        >
          Upload
        </button>
        
        </>
      );
    }

    return <span>Closed</span>;
  };
  
  const handleViewAnswers = (answer) => {
    const studentAnswers = JSON.parse(answer || "{}");

    const correctAnswers = {};

    selectedResult?.examData?.questions?.forEach((q) => {
      correctAnswers[q.question_no] = q.answer;
    });

    setSelectedAnswers({ studentAnswers, correctAnswers });
    setShowAnswerModal(true);
  };


  

  return (
    <>
      <div className="container mt-4">
        <h4 className="mb-3">Exam List</h4>

     <div className="col-12 col-md-4 mb-3">
                            <input
                                type="text"
                                className="form-control border-info "
                                placeholder="Search by exam..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
    

        {(!selectedExam && !selectedUploadExam) && (
          <div className="table-responsive">
            <table className="table table-bordered text-center">
              <thead className="table-dark">
                <tr>
                  <th>Exam</th>
                  <th>Questions</th>
                  <th>Options</th>
                  <th>Status</th>
                  <th>Correct Marks</th>
                  <th>Wrong Marks</th>
                  <th>Penalty</th>
                  <th>Activity</th>
                </tr>
              </thead>
              <tbody>
                {visibleData.map((exam) => (
                  <tr key={exam.id}>
                    <td>{exam.exam_title}</td>
                    <td>{exam.total_questions}</td>
                    <td>{exam.option_count}</td>
                    <td>{exam.status}</td>
                    <td>{exam.correct_marks}</td>
                    <td>{exam.wrong_marks}</td>
                    <td>{exam.penalty}</td>
                    <td>{renderActivity(exam)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* OMR Scanner */}
      {selectedExam && (
        <OMRScanner
          examId={selectedExam.id}
          questions={selectedExam.questions}
          studentId={student.id}
          classId={student.class_id}
          penalty={selectedExam.penalty}
          setSelectedExam={setSelectedExam}
          onResult={handleResult}
        />
      )}


      {selectedUploadExam && (
        <Scanner
          // examId={selectedExam.id}
          // questions={selectedExam.questions}
          studentId={student.id}
          // classId={student.class_id}
          // penalty={selectedExam.penalty}
          exam={selectedUploadExam}
          onResult={handleUploadResult}
          onCancel={() => setSelectedUploadExam(null)}
        />
      )}


            <Modal
        show={showResult}
        onHide={() => setShowResult(null)}
        size="lg"
        centered
      >
                <Modal.Header closeButton>
          <Modal.Title>Answer Sheet</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
    
          <p className="text-start"><b className="text-success">Correct:</b> {showResult?.correct} <b className="ps-4 text-danger">Wrong:</b> {showResult?.wrong}</p>
{/* <b>Score:</b> {showResult.score}  */}
        <img
          src={
            showResult?.annotatedImage
              ? showResult?.annotatedImage
              : showResult?.imageUrl
          }
          alt="OMR Sheet"
          style={{ maxWidth: "60%", height: '60%' }}
        />

 </Modal.Body> </Modal>





      {/* Result Modal */}
      {/* {selectedResult && (
        <div className="modal show d-block">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-3">
              <h4>{selectedResult.examData.exam_title || ''} Result</h4>



{(() => {
  let parsedAnswers = {};

  if (selectedResult.answer) {
    try {
      parsedAnswers = JSON.parse(selectedResult.answer);
    } catch (err) {
      console.error("Failed to parse answers:", err);
    }
  }

  const examData = selectedResult.examData;

  const totalQuestions = examData?.total_questions || 0;

  const correct = Number(selectedResult.correct || 0);
  const wrong = Number(selectedResult.wrong || 0);

  const penaltyPerQ = Number(examData?.penalty || 0);


  const attempted = correct + wrong;
  const unattempted = totalQuestions - attempted;


  const getMarksConfig = (q) => {
    return {
      correct: Number(q?.correct_marks ?? examData?.correct_marks ?? 0),
      wrong: Number(q?.wrong_marks ?? examData?.wrong_marks ?? 0),
    };
  };

  let totalCorrectMarks = 0;
  let totalWrongMarks = 0;

  const answers = parsedAnswers;

  examData?.questions?.forEach((q) => {
    const qNo = String(q.question_no);

    const studentAnswer = String(answers[qNo] ?? "")
      .trim()
      .toUpperCase();

    const correctAns = String(q.answer || "")
      .trim()
      .toUpperCase();

    const { correct: correctMark, wrong: wrongMark } = getMarksConfig(q);


    if (examData?.option_count === 4 && studentAnswer === "E") {
      return;
    }


    if (studentAnswer === "" || studentAnswer === "-") {
      return;
    }


    if (studentAnswer === correctAns) {
      totalCorrectMarks += correctMark;
    }

    else {
      totalWrongMarks += wrongMark;
    }
  });

  const totalPenaltyMarks = unattempted * penaltyPerQ;

  const finalTotal =
    totalCorrectMarks - totalWrongMarks - totalPenaltyMarks;


return (
  <div className="mt-3">
    <div className="table-responsive">
      <h5 className="text-primary mt-3">Question Summary</h5>
      <table className="table table-bordered text-center">
        <thead className="table-light">
          <tr>
            <th>Total Qs</th>
            <th>Attempted</th>
            <th>Correct</th>
            <th>Wrong</th>
            <th>Unanswered</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{totalQuestions}</td>
            <td>{attempted}</td>
            <td className="text-success fw-semibold">{correct}</td>
            <td className="text-danger fw-semibold">{wrong}</td>
            <td className="text-warning fw-semibold">{unattempted}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="table-responsive mt-3">
      <h5 className="text-primary mt-4">Marks Breakdown</h5>
      <table className="table table-bordered text-center">
        <thead className="table-light">
          <tr>
            <th>Correct Marks</th>
            <th>Wrong Marks</th>
            <th>Penalty</th>
            <th>Obtained Marks</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-success fw-bold">{totalCorrectMarks.toFixed(2)}</td>
            <td className="text-danger fw-bold">- {totalWrongMarks.toFixed(2)}</td>
            <td className="text-warning fw-bold">- {totalPenaltyMarks.toFixed(2)}</td>
            <td className="fw-bold fs-5">{finalTotal.toFixed(2)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);
})()}


 <button
                className="btn btn-primary mt-3"
                onClick={() => handleViewAnswers(selectedResult.answer)}
              >
                View Answers
              </button>
              <button
                className="btn btn-danger mt-3"
                onClick={() => {setSelectedResult(null); setShowAnswerModal(false)}}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )} */}


    {selectedResult && (
        <div className="modal show d-block">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-3">
              <h4>{selectedResult.examData.exam_title || ''} Result</h4>
{(() => {
  let parsedAnswers = {};

  if (selectedResult.answer) {
    try {
      parsedAnswers = JSON.parse(selectedResult.answer);
    } catch (err) {
      console.error("Failed to parse answers:", err);
    }
  }

  const examData = selectedResult.examData;

  const totalQuestions = examData?.total_questions || 0;
  const penaltyPerQ = Number(examData?.penalty || 0);

  
  // const correct = Number(selectedResult.correct || 0);
  // const wrong = Number(selectedResult.wrong || 0);

  // const attempted = correct + wrong;
  // const unattempted = totalQuestions - attempted;


  const answers = parsedAnswers;

let attempted = 0;

Object.values(answers).forEach((ans) => {
  const value = String(ans ?? "").trim().toUpperCase();

  if (value !== "" && value !== "-" && value !== "E") {
    attempted++;
  }
});

const unattempted = totalQuestions - attempted;

// // Keep these from the database
// const correct = Number(selectedResult.correct || 0);
// const wrong = Number(selectedResult.wrong || 0);


let correct = 0;
let wrong = 0;

Object.entries(answers).forEach(([qNo, ans]) => {
  const studentAnswer = String(ans ?? "")
    .trim()
    .toUpperCase();

  if (studentAnswer === "" || studentAnswer === "-" || studentAnswer === "E") {
    return;
  }

  const question = examData?.questions?.find(
    (q) => String(q.question_no) === String(qNo)
  );

  if (!question) return;

  const correctAnswer = String(question.answer || "")
    .trim()
    .toUpperCase();

  if (studentAnswer === correctAnswer) {
    correct++;
  } else {
    wrong++;
  }
});


  const getMarksConfig = (q) => {
    return {
      correct: Number(q?.correct_marks ?? examData?.correct_marks ?? 0),
      wrong: Number(q?.wrong_marks ?? examData?.wrong_marks ?? 0),
    };
  };

  // let totalCorrectMarks = 0;
  // let totalWrongMarks = 0;



  // examData?.questions?.forEach((q) => {
  //   const qNo = String(q.question_no);

  //   const studentAnswer = String(answers[qNo] ?? "")
  //     .trim()
  //     .toUpperCase();

  //   const correctAns = String(q.answer || "")
  //     .trim()
  //     .toUpperCase();

  //   const { correct: correctMark, wrong: wrongMark } = getMarksConfig(q);


  //   if (examData?.option_count === 4 && studentAnswer === "E") {
  //     return;
  //   }


  //   if (studentAnswer === "" || studentAnswer === "-") {
  //     return;
  //   }


  //   if (studentAnswer === correctAns) {
  //     totalCorrectMarks += correctMark;
  //   }

  //   else {
  //     totalWrongMarks += wrongMark;
  //   }
  // });
  

  let totalCorrectMarks = 0;
let totalWrongMarks = 0;

Object.entries(answers).forEach(([qNo, ans]) => {
  const studentAnswer = String(ans ?? "")
    .trim()
    .toUpperCase();

  if (
    studentAnswer === "" ||
    studentAnswer === "-" ||
    (examData?.option_count === 4 && studentAnswer === "E")
  ) {
    return;
  }

  const question = examData.questions.find(
    (q) => String(q.question_no) === String(qNo)
  );

  if (!question) return;

  const correctAnswer = String(question.answer || "")
    .trim()
    .toUpperCase();

  const correctMark = Number(
    question.correct_marks ?? examData.correct_marks ?? 0
  );

  const wrongMark = Number(
    question.wrong_marks ?? examData.wrong_marks ?? 0
  );

  if (studentAnswer === correctAnswer) {
    totalCorrectMarks += correctMark;
  } else {
    totalWrongMarks += wrongMark;
  }
});



  const totalPenaltyMarks = unattempted * penaltyPerQ;

  const finalTotal =
    totalCorrectMarks - totalWrongMarks - totalPenaltyMarks;

  return (
    <div className="mt-3">

      {/* SUMMARY TABLE */}
      <div className="table-responsive">
        <h5 className="text-primary mt-3">Question Summary</h5>

        <table className="table table-bordered text-center">
          <thead className="table-light">
            <tr>
              <th>Total Qs</th>
              <th>Attempted</th>
              <th>Correct</th>
              <th>Wrong</th>
              <th>Unanswered</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>{totalQuestions}</td>
              <td>{attempted}</td>
              <td className="text-success fw-semibold">{correct}</td>
              <td className="text-danger fw-semibold">{wrong}</td>
              <td className="text-warning fw-semibold">{unattempted}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* MARKS TABLE */}
      <div className="table-responsive mt-3">
        <h5 className="text-primary mt-4">Marks Breakdown</h5>

        <table className="table table-bordered text-center">
          <thead className="table-light">
            <tr>
              <th>Correct Marks</th>
              <th>Wrong Marks</th>
              <th>Penalty</th>
              <th>Obtained Marks</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="text-success fw-bold">
                {Number(totalCorrectMarks).toFixed(2)}
              </td>

              <td className="text-danger fw-bold">
                - {Number(totalWrongMarks).toFixed(2)}
              </td>

              <td className="text-warning fw-bold">
                - {Number(totalPenaltyMarks).toFixed(2)}
              </td>

              <td className="fw-bold fs-5">
                {Number(finalTotal).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
})()}


 <button
                className="btn btn-primary mt-3"
                onClick={() => handleViewAnswers(selectedResult.answer)}
              >
                View Answers
              </button>
              <button
                className="btn btn-danger mt-3"
                onClick={() => {setSelectedResult(null); setShowAnswerModal(false)}}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />

            <Modal
        show={showAnswerModal}
        onHide={() => setShowAnswerModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Answer Sheet</Modal.Title>
        </Modal.Header>

        <Modal.Body>
  {!selectedAnswers && <p>No data available</p>}



  {selectedAnswers && (
  <div className="table-responsive">
    <table className="table table-bordered text-center">
      <thead>
        <tr>
          <th>Q No</th>
          <th>Correct Answer</th>
          <th>Student Answer</th>
          <th>Status</th>
          <th>Marks</th>
        </tr>
      </thead>

      <tbody>
        {Object.keys(selectedAnswers.correctAnswers || {}).map((qNo) => {
          const correct = selectedAnswers.correctAnswers[qNo];
          const studentAnswer = selectedAnswers.studentAnswers[qNo];

          const question = selectedResult?.examData?.questions?.find(
            (q) => q.question_no.toString() === qNo
          );

          const examData = selectedResult?.examData;

          const ans = String(studentAnswer || "").trim().toUpperCase();

          let status = "Not Attempted";
          let color = "gray";
          let marks = 0;

          const correctMarks = Number(
            question?.correct_marks ?? examData?.correct_marks ?? 0
          );
          const wrongMarks = Number(
            question?.wrong_marks ?? examData?.wrong_marks ?? 0
          );
          const penaltyMarks = Number(
            question?.penalty ?? examData?.penalty ?? 0
          );
    
          if (examData?.option_count === 4 && ans === "E") {
            status = "Skipped";
            color = "orange";
            marks = 0;
          }

          else if (!studentAnswer || studentAnswer == "" || studentAnswer == '-') {
            status = "Not Attempted";
            color = "gray";
            marks = -penaltyMarks;
          }

       
          else if (ans === correct) {
            status = "Correct";
            color = "green";
            marks = correctMarks;
          }

       
          else {
            status = "Wrong";
            color = "red";
            marks = -wrongMarks;
          }

          return (
            <tr key={qNo}>
              <td>{qNo}</td>
              <td>{correct}</td>
              <td>{studentAnswer || "-"}</td>
              <td style={{ color }}>{studentAnswer == '' ? 'Penalty' : status}</td>
              <td>{marks}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
)}



</Modal.Body>
      </Modal>
    </>
  );
};

export default Exam;